/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `VendorCache.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { VendorCache } from "./VendorCache";

export type integrationSource =
    | "user_upload"
    | "procore"
    | "procore_sandbox"
    | "autodesk_construction"
    | "cmic"
    | "primavera_p6"
    | "microsoft_project"
    | "asta_power_project"
    | "faker"
    | "api_upload";

export const integrationSourceValues = {
    user_upload: 0,
    procore: 1,
    procore_sandbox: 2,
    autodesk_construction: 3,
    cmic: 4,
    primavera_p6: 5,
    microsoft_project: 6,
    asta_power_project: 7,
    faker: 8,
    api_upload: 9,
};

export abstract class VendorCacheModel {
    id: number;
    cacheableId: number | null;
    cacheableType: string | null;
    createdAt: Dayjs;
    data: any | null;
    integrationSource: integrationSource;
    lastSynced: Dayjs | null;
    updatedAt: Dayjs;
    vendorRecordId: string | null;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        cacheableId: number | null,
        cacheableType: string | null,
        createdAt: Dayjs,
        data: any | null,
        integrationSource: integrationSource,
        lastSynced: Dayjs | null,
        updatedAt: Dayjs,
        vendorRecordId: string | null
    ) {
        this.id = id;
        this.cacheableId = cacheableId;
        this.cacheableType = cacheableType;
        this.createdAt = createdAt;
        this.data = data;
        this.integrationSource = integrationSource;
        this.lastSynced = lastSynced;
        this.updatedAt = updatedAt;
        this.vendorRecordId = vendorRecordId;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): VendorCache {
        const newObject = new VendorCache(
            json["id"],
            json["cacheable_id"],
            json["cacheable_type"],
            dayjs(json["created_at"]).tz(timezone),
            json["data"],
            json["integration_source"],
            json["last_synced"] ? dayjs(json["last_synced"]).tz(timezone) : null,
            dayjs(json["updated_at"]).tz(timezone),
            json["vendor_record_id"]
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            cacheable_id: this.cacheableId,
            cacheable_type: this.cacheableType,
            created_at: this.createdAt,
            data: this.data,
            integration_source: this.integrationSource,
            last_synced: this.lastSynced,
            updated_at: this.updatedAt,
            vendor_record_id: this.vendorRecordId,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): VendorCache {
        const clone = Object.create(this) as VendorCache;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
